import React from "react";
import { AHText, AHTextFonts, ListItem } from "arkh";

import { FileIcon, FileIconRelay } from "./FileIcon";
import { graphql, useFragment } from "react-relay";
import {
  FileListItem_file$key,
  FileType,
} from "./__generated__/FileListItem_file.graphql";
import { FormattedDate } from "../../../common/dates/FormattedDate";

function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(find, "g"), replace);
}

export const FileIntegrationListItem = (props: {
  onPress(): void;
  title: string;
  isFirst: boolean;
  isLast: boolean;
}) => {
  return (
    <ListItem
      onPress={props.onPress}
      isFirst={props.isFirst}
      isLast={props.isLast}
      left={<FileIcon filetype="integration" />}
    >
      <ListItem.Title>
        <AHText numberOfLines={1} type="subtitle" color="darkerText">
          {props.title}
        </AHText>
      </ListItem.Title>
    </ListItem>
  );
};

export const FileListItem = (props: {
  isFirst: Readonly<boolean>;
  isLast: Readonly<boolean>;
  textHighlights: readonly { text: string; isHighlighted: boolean }[];
  nameHighlights: readonly { text: string; isHighlighted: boolean }[];
  onPress: (file: {
    url: string;
    fileId: string;
    fileName: string;
    fileType: FileType | null;
  }) => void;
  file: FileListItem_file$key;
}) => {
  const file = useFragment(
    graphql`
      fragment FileListItem_file on File {
        id

        createdAtDate {
          ...FormattedDate
        }
        url
        type
        name
        ...FileIcon_File
      }
    `,
    props.file
  );
  return (
    <ListItem
      onPress={() =>
        props.onPress({
          fileId: file.id,
          fileName: file.name ?? "",
          fileType: file.type,
          url: file.url,
        })
      }
      isFirst={props.isFirst}
      isLast={props.isLast}
      left={<FileIconRelay file={file} />}
      right={
        <>
          <AHText type="detail">
            <FormattedDate date={file.createdAtDate} />
          </AHText>
        </>
      }
    >
      <ListItem.Title>
        {props.nameHighlights.length < 2 ? (
          <AHText type="subtitle" color="darkerText">
            {file.name}
          </AHText>
        ) : (
          props.nameHighlights.map((v, i) => (
            <AHText
              type="subtitle"
              style={{ flex: 1 }}
              font={v.isHighlighted ? AHTextFonts.BOLDER : undefined}
              color={v.isHighlighted ? "darkerText" : "darkText"}
              key={i}
            >
              {replaceAll(v.text, "\n", " ")}
            </AHText>
          ))
        )}
      </ListItem.Title>

      {props.textHighlights.length > 0 ? (
        <AHText
          style={{ flex: 1 }}
          type="detail"
          color="darkText"
          cornerRadius="small"
          numberOfLines={1}
        >
          &quot;
          {props.textHighlights.map((v, i, arr) => {
            const t =
              i === 0
                ? v.text.trimStart()
                : i === arr.length - 1
                  ? v.text.trimEnd()
                  : v.text;
            return (
              <AHText
                font={v.isHighlighted ? AHTextFonts.BOLD : AHTextFonts.MEDIUM}
                style={{ flex: 1 }}
                color={v.isHighlighted ? "darkerText" : "darkText"}
                key={i}
              >
                {replaceAll(t, "\n", " ")}
              </AHText>
            );
          })}
          &quot;
        </AHText>
      ) : null}
    </ListItem>
  );
};
